<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 class="mt-2 text-3xl text-gray-900">Mensagens Proibidas</h1>
          <p class="mt-2 max-w-2xl text-sm text-gray-500">Configure palavras e frases bloqueadas para prevenir envios indevidos no atendimento.</p>
        </div>

        <div class="flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            class="icon-anim-trigger--back group flex h-11 items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-5 font-medium text-gray-700 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:bg-gray-50 hover:shadow-md"
            @click="voltar"
          >
            <svg class="icon-anim icon-anim--back h-5 w-5 text-gray-500 group-hover:text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.75 19.5L8.25 12l7.5-7.5" />
            </svg>
            Voltar
          </button>
        </div>
      </div>

      <div class="rounded-2xl border border-gray-200 bg-white p-6">
        <div class="grid grid-cols-1 gap-4 md:grid-cols-4">
          <div class="flex flex-col gap-1 md:col-span-2">
            <label class="text-sm font-medium text-gray-500">Frase ou observação</label>
            <input
              v-model="filtroBusca"
              type="text"
              placeholder="Buscar conteúdo bloqueado"
              class="h-11 w-full rounded-xl border border-gray-200 bg-white px-4 text-gray-700 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
            />
          </div>

          <div class="flex flex-col gap-1">
            <label class="text-sm font-medium text-gray-500">Categoria</label>
            <div class="relative group">
              <select
                v-model="filtroCategoria"
                class="w-full h-11 px-4 pr-10 border border-gray-200 rounded-xl bg-white bg-none text-gray-700 shadow-sm appearance-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100 cursor-pointer"
              >
                <option value="todos">Todas</option>
                <option value="geral">Geral</option>
                <option value="atendimento">Atendimento</option>
                <option value="financeiro">Financeiro</option>
                <option value="operacional">Operacional</option>
              </select>
              <svg class="select-icon w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>

          <div class="flex flex-col gap-1 md:col-span-4 lg:col-span-1">
            <label class="text-sm font-medium text-gray-500">Ações</label>
            <div class="flex items-center gap-2">
              <button @click="aplicarFiltros" type="button" class="h-11 w-full rounded-xl bg-blue-500 px-4 font-medium text-white transition hover:bg-blue-600">Buscar</button>

              <button @click="limparFiltros" type="button" class="h-11 rounded-xl border border-gray-200 bg-white px-4 font-medium text-gray-700 transition hover:bg-gray-50">Limpar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-2 flex justify-end">
        <router-link to="/operadores/msgproibida/nova" class="group flex w-full items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-5 py-3 shadow-sm transition hover:shadow-md sm:w-auto">
          <heroicon name="plus-circle" class="h-6 w-6 text-green-600 transition-colors group-hover:text-green-700" />
          <span class="text-sm font-medium text-gray-700">Nova mensagem proibida</span>
        </router-link>
      </div>

      <div class="w-full overflow-hidden sm:rounded-lg border border-gray-200 bg-white shadow-sm">
        <div class="overflow-x-auto">
          <table class="w-full min-w-max text-sm">
            <thead class="border-b bg-gray-100 tracking-wider text-gray-600">
              <tr>
                <th class="px-6 py-4 text-left font-medium">Frase / Palavra</th>
                <th class="px-6 py-4 text-left font-medium">Categoria</th>
                <th class="px-6 py-4 text-left font-medium">Observação</th>
                <th class="px-6 py-4 text-left font-medium">Cadastro</th>
                <th class="px-6 py-4 text-center font-medium">Ações</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="item in list" :key="item._id" class="border-b border-gray-100 transition hover:bg-slate-50">
                <td class="px-6 py-5 font-medium text-gray-800">{{ item.frase || "-" }}</td>
                <td class="px-6 py-5">
                  <span class="rounded-full bg-blue-100 px-3 py-1 text-xs text-blue-700">
                    {{ formatCategoria(item.categoria) }}
                  </span>
                </td>
                <td class="px-6 py-5 text-gray-600">{{ item.observacao || "-" }}</td>
                <td class="px-6 py-5 text-gray-600">{{ formatDate(item.createdAt) }}</td>
                <td class="px-6 py-5">
                  <div class="flex flex-wrap justify-center gap-2">
                    <router-link :to="`/operadores/msgproibida/${item._id}`" class="rounded-lg bg-blue-500 px-4 py-2 text-sm text-white transition hover:bg-blue-600"> Editar </router-link>

                    <button @click="remove(item._id)" type="button" class="rounded-lg bg-red-700 px-4 py-2 text-sm text-white transition hover:bg-red-800">Remover</button>
                  </div>
                </td>
              </tr>

              <tr v-if="list.length === 0">
                <td colspan="5" class="px-6 py-12 text-center text-sm text-gray-400">Nenhuma mensagem proibida encontrada com os filtros atuais.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <pagination v-model="page" :per-page="perPage" :records="total" @paginate="setPage" class="pagination" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      perPage: 25,
      filtroBusca: "",
      filtroCategoria: "todos",
      busca: "",
      categoria: "todos",
      list: [],
      total: 0
    };
  },
  methods: {
    voltar() {
      this.$router.push({ path: "/operadores" });
    },
    formatDate(value) {
      if (!value) return "-";
      return new Date(value).toLocaleString("pt-BR");
    },
    formatCategoria(value) {
      if (!value) return "Geral";
      const labels = {
        geral: "Geral",
        atendimento: "Atendimento",
        financeiro: "Financeiro",
        operacional: "Operacional"
      };
      return labels[value] || value;
    },
    aplicarFiltros() {
      this.busca = this.filtroBusca;
      this.categoria = this.filtroCategoria;
      this.setPage(1);
    },
    limparFiltros() {
      this.filtroBusca = "";
      this.filtroCategoria = "todos";
      this.busca = "";
      this.categoria = "todos";
      this.setPage(1);
    },
    async setPage(page) {
      this.page = page;
      const skip = (page - 1) * this.perPage;
      const limit = this.perPage;

      const resp = await this.$http.post("/v1/operador/msgproibida/list", {
        busca: this.busca,
        categoria: this.categoria,
        skip,
        limit
      });

      this.list = resp.data.data || [];
      this.total = resp.data.total || 0;
    },
    async remove(id) {
      if (!confirm("Tem certeza que deseja remover esta mensagem proibida?")) {
        return;
      }

      const resp = await this.$http.delete(`/v1/operador/msgproibida/${id}`);
      if (!resp.data.success) {
        this.$vToastify.error(resp.data.err || "Não foi possível remover.");
        return;
      }

      this.$vToastify.success("Mensagem proibida removida");
      this.setPage(this.page);
    }
  },
  async beforeMount() {
    this.setPage(1);
  }
};
</script>

<style scoped>
:deep(.heroicon-ui) {
  fill: currentColor !important;
}

.icon-anim {
  transition: transform 0.2s ease;
}

.icon-anim-trigger--back:hover .icon-anim--back,
.icon-anim-trigger--back:focus-visible .icon-anim--back {
  transform: translateX(-4px);
}

.select-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  pointer-events: none;
  color: #9ca3af;
  transform: translateY(-50%);
  transition: transform 0.2s ease, color 0.2s ease;
}

.group:focus-within .select-icon {
  color: #6366f1;
  transform: translateY(-50%) rotate(180deg);
}
</style>
